import CheckAvail, {
	CHECK_AVAIL_EVENTS,
} from '@resources/js/components/check-avail/CheckAvail'
import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import HotelCard from '@resources/js/components/hotel-card/HotelCard'
import Modal from '@resources/js/ui/Modal'
import Toggle from '@resources/js/ui/Toggle'

import { prepareSearchData } from '@resources/js/components/check-avail/helpers'
import { parse } from '@formkit/tempo'
import { convertObjectToUrlParam } from '@resources/js/helpers/convert-obj-to-url-param-string'
import { updateFormInfoView } from '@resources/js/components/form/helpers/updateFormInfoView'
import { isDesktop } from '@resources/js/helpers/media'
import '@resources/js/analytics'
import sendClickunderStats from '@resources/js/components/clickunderStats'
import generateBcomUrl from '@resources/js/helpers/generateBcomUrl'
import generateBcomParamsFromFormData from '@resources/js/helpers/generateBcomParamsFromFormData'
import NotAvail, {
	NOT_AVAIL_EVENTS,
} from '@resources/js/components/not-avail/NotAvail'
import {
	increaseNotAvailCount,
	getNotAvailCount,
	resetNotAvailCount,
} from '@resources/js/components/not-avail/notAvailCounter'
import NotAvailFilters, {
	NOT_AVAIL_FILTERS_EVENTS,
} from '@resources/js/components/not-avail-filters/NotAvailFilters'

import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'
import {
	createSearchMarkerTemplate,
	createSearchPopupTemplate,
} from '@resources/js/maps/helpers'

import FiltersStore from '@resources/js/components/filters/FiltersStore'
import FiltersPresenter from '@resources/js/components/filters/FiltersPresenter'
import FiltersView from '@resources/js/components/filters/FiltersView'
import {
	FILTERS_PRESENTER_EVENTS,
	FILTERS_STORE_EVENTS,
} from '@resources/js/components/filters/filterEvents'
import { syncFiltersStoreWithUrl } from '@resources/js/components/filters/filtersUrlSync'
import {
	parseFiltersFromString,
	getAvailableFilters,
	getSelectedFiltersCount,
	parseJsonScript,
	parseCategoryLabels,
} from '@resources/js/components/filters/helpers'
import QuickFiltersView from '@resources/js/components/filters/quick-filters/QuickFiltersView'
import QuickFiltersPresenter from '@resources/js/components/filters/quick-filters/QuickFiltersPresenter'

const searchDataElement = document.getElementById('search-data') // елемент з параметрами пошуку

// валідація параметрів пошуку відбувається на бекенді, якщо searchDataElement не існує - валідація не пройдена
// тимчасова логіка в разі передачі не валідних параметрів
if (!searchDataElement) location.href = window.location.origin

// інітимо стор форми
const formStore = new FormStore()

// розпаршуємо параметри пошуку
const searchData = JSON.parse(searchDataElement.textContent)

// фільтри, прокинуті з попередньої сторінки
// може бути відсутній, якщо перехід стався без фільтрів
const filterDataElement = document.getElementById('filter-data')
const initialFilterParams = filterDataElement
	? JSON.parse(filterDataElement.textContent)
	: {}

// оновлюємо стор відповідно переданим данним пошуку
formStore.setProperty('checkIn', parse(searchData.checkIn))
formStore.setProperty('checkOut', parse(searchData.checkOut))
formStore.setProperty('adultsCount', searchData.adults)
formStore.setProperty('childrenCount', searchData.childrens.length)
searchData.childrens.forEach((childAge, i) => formStore.addChildObj(i, childAge))

const calendarConfig = {
	defaultDate: [parse(searchData.checkIn), parse(searchData.checkOut)],
	showMonths: 1,
	locale: {
		firstDayOfWeek: 1, // 0 — неділя, 1 — понеділок
	},
}

const DATE_FORMAT = 'MMM DD' //Jun 03

const isDesktopView = isDesktop()

// інітимо форму
const headerElement = document.querySelector('.js-header')
const mainFormElement = headerElement.querySelector('.js-header-form-wrapper')

const mainFormView = new FormView(mainFormElement, { calendarConfig })
const mainFormPresenter = new FormPresenter(mainFormView, formStore, DATE_FORMAT)

// починаючи з таблета форма знаходиться в модалці
// зберігаємо інстанс для not-avail notice
const headerFormModal = !isDesktopView
	? new Modal(mainFormElement, {
			trigger: headerElement.querySelector('.js-show-form-trigger'),
			selectors: {
				close: '.js-close-form',
				content: '.js-header-form',
			},
		})
	: null

// avail init
const checkAvail = new CheckAvail()

const mapLoader = new Toggle(null, {
	target: '.js-search-loader',
})

// карту інітимо до старту евейлу, щоб вона вантажилась паралельно з ним
// маркери домальовуються в renderSearchResults() після отримання результатів
const mapOptions = {
	zoom: 12,
	control: 'top-right',
}

const map = new MapView(mapOptions)
const mapHotelsStore = new MapHotelsStore()

const notAvailNotices = {
	dates: null,
	filters: null,
}

checkAvail.on(CHECK_AVAIL_EVENTS.START, () => {
	mapLoader.show()

	// закриваємо модалки, якщо юзер запустив нову перевірку доступності
	notAvailNotices.dates?.hide()
	notAvailNotices.filters?.hide()
})
checkAvail.on(CHECK_AVAIL_EVENTS.FINISH, () => mapLoader.hide())

const cityId = searchData.cityId
const langId = shared.options.language.id
const currency = shared.options.currency

const formStoreData = formStore.getData()

try {
	await checkAvail.init({
		...prepareSearchData(formStoreData, cityId, langId),
		...initialFilterParams,
		currency: currency.code,
	})
} catch (err) {
	// помилка запиту або відсутність готелів
	// далі спрацює сценарій not-avail
	console.error(err)
}

const availableFilters = getAvailableFilters(checkAvail.filters)
const initialFiltersState = parseFiltersFromString(initialFilterParams)

const filtersStore = new FiltersStore(availableFilters, initialFiltersState)
syncFiltersStoreWithUrl(filtersStore)

const filtersModalElement = document.querySelector('.js-filters-popup')

const filtersModal = new Modal(filtersModalElement, {
	trigger: '.js-search-filters-trigger',
	selectors: {
		content: '.js-filters-popup-content',
	},
})

const filtersElement = filtersModalElement.querySelector('.js-filters')

const filtersView = new FiltersView(checkAvail.filters, filtersElement)
const filtersPresenter = new FiltersPresenter(filtersView, filtersStore)

// при відкритті оновлюємо фільтри за актуальним станом стору
filtersModal.on('show', () => filtersView.resetToAppliedFilters())

const filtersCounterElement = document.querySelector('.js-search-filters-counter')

const updateFiltersCounter = () => {
	const count = getSelectedFiltersCount(filtersStore.getData())

	filtersCounterElement.textContent = count
	filtersCounterElement.classList.toggle('hidden', count === 0)
}

updateFiltersCounter()

// лічильник слухає стор напряму — так він реагує і на панель, і на чипси, і на reset
filtersStore.on(FILTERS_STORE_EVENTS.CHANGE, updateFiltersCounter)
filtersStore.on(FILTERS_STORE_EVENTS.CLEAR, updateFiltersCounter)

filtersPresenter.on(FILTERS_PRESENTER_EVENTS.APPLY, () => filtersModal.hide())

// результати пошуку оновлюються на будь-яку зміну фільтрів — з панелі, чипсів чи reset
filtersStore.on(FILTERS_STORE_EVENTS.CHANGE, () => refetchAndRenderAvail())
filtersStore.on(FILTERS_STORE_EVENTS.CLEAR, () => refetchAndRenderAvail())

// швидкі фільтри (ряд чипсів + попап категорії) — свої view і презентер, спільний лише стор
const quickFiltersView = new QuickFiltersView(document.querySelector('.js-quick-filters'))
new QuickFiltersPresenter(quickFiltersView, filtersStore, {
	presets: parseJsonScript('quick-filters-presets'),
	filtersData: checkAvail.filters,
	categoryLabels: parseCategoryLabels('filters-category-labels'),
})

const handleFormSubmit = async formData => {
	const data = {
		...prepareSearchData(formData, cityId, langId),
		...filtersStore.getData(),
		cur_id: currency.id,
	}
	const urlParamsString = convertObjectToUrlParam(data)

	const newUrl = window.location.origin + '/search/?' + urlParamsString
	location.href = newUrl
}

mainFormPresenter.on('form-submit', handleFormSubmit)

// елементи та інстанси, що живуть протягом усієї сторінки й повторно
// використовуються на кожному renderSearchResults()
const hotelsContainerElement = document.querySelector('.js-hotels-container')
const hotelTemplateElement = hotelsContainerElement.querySelector(
	'#search-hotel-template'
)

const handleHotelClickunder = hotelId => {
	const type = 'property'

	const bcomUrl = generateBcomUrl({
		...generateBcomParamsFromFormData({ type, formData: formStore.getData() }),
		destId: hotelId,
		bid: hotelId,
		destType: 'hotel',
	})

	sendClickunderStats({ type, partnerUrl: bcomUrl })

	window.open(bcomUrl, '_blank')
}

const renderSearchResults = () => {
	// картки готелів
	hotelsContainerElement.replaceChildren()

	const availableHotelsArray = checkAvail.availableHotels
	const hotelCardsInstances = availableHotelsArray.map(
		hotel => new HotelCard(hotel, { hotelTemplateElement })
	)

	hotelsContainerElement.append(
		...hotelCardsInstances.map(hotelCardInstance => hotelCardInstance.element)
	)

	// оновлюємо стор даних карти зі свіжих карток у DOM і перемальовуємо маркери
	mapHotelsStore.syncData()
	const hotelsData = mapHotelsStore.getData()

	map.clearMarkers()
	map.addMarkers(hotelsData, createSearchMarkerTemplate)

	// додаємо попапи до маркерів
	const popupData = hotelsData.map(hotel => ({
		id: hotel.id,
		name: hotel.name,
		price: hotel.price,
		biggerPrice: hotel.biggerPrice,
		stars: hotel.stars,
		photo: hotel.photo,
		rating: hotel.rating,
		reviewPhrase: hotel.reviewPhrase,
		reviewsCount: hotel.reviewsCount,
	}))

	popupData.forEach(item => {
		const popup = map.setPopupToMarkerById(
			item.id,
			createSearchPopupTemplate(item)
		)
		if (!popup) return

		// Додаємо обробник на подію відкриття попапу
		popup.on('open', () => {
			map.lockMarker(item.id)
			map.setMarkerViewed(item.id)

			const popupElement = popup.getElement()
			const closeBtn = popupElement.querySelector('.js-close-popup')

			if (closeBtn)
				closeBtn.addEventListener('click', () => map.closePopupById(item.id))

			popupElement.addEventListener('click', e => {
				if (closeBtn?.contains(e.target)) return

				handleHotelClickunder(item.id)
			})
		})

		// Додаємо обробник на подію закриття попапу
		popup.on('close', () => map.unlockMarker(item.id))
	})

	// логіка готельних карток
	hotelCardsInstances.forEach(hotelCard => {
		const hotelId = hotelCard.element.dataset.bhotelId

		hotelCard.on('main-btn-click', () => handleHotelClickunder(hotelId))

		hotelCard.element.addEventListener('mouseenter', () =>
			map.activateMarker(hotelId)
		)

		hotelCard.element.addEventListener('mouseleave', () =>
			map.resetActivePlaces()
		)
	})
}

const refetchAndRenderAvail = async () => {
	try {
		const isLatest = await checkAvail.refetch({
			...prepareSearchData(formStoreData, cityId, langId),
			...filtersStore.getData(),
			currency: currency.code,
		})

		// поки запит ішов, стартував новіший — рендерити буде він
		if (!isLatest) return

		renderSearchResults()
		showNotAvailIfNeeded()
	} catch (err) {
		// TODO: узгодити поведінку при мережевій помилці з командою
		console.error(err)
	}
}

// сценарій not-avail
const openBcom = () => {
	const formData = formStore.getData()
	const paramsForBcomUrl = generateBcomParamsFromFormData({
		type: 'calendar-form',
		formData,
	})

	const bcomUrl = generateBcomUrl(paramsForBcomUrl)

	sendClickunderStats({ type: 'calendar-form', partnerUrl: bcomUrl })

	window.open(bcomUrl, '_blank')
}

const showNotAvailDates = () => {
	increaseNotAvailCount()

	if (!notAvailNotices.dates) {
		const MIN_ATTEMPTS_FOR_CLKNDR = 2

		notAvailNotices.dates = new NotAvail()

		notAvailNotices.dates.on(NOT_AVAIL_EVENTS.CLOSE, () => {
			// умова спрацювання відкриття букінгком
			if (getNotAvailCount() >= MIN_ATTEMPTS_FOR_CLKNDR) openBcom()

			if (!isDesktopView) headerFormModal?.show()

			mainFormView.openCalendar()
		})

		// якщо користувач сам відкриває форму — ховаємо нотіс
		if (!isDesktopView)
			headerFormModal?.on('show', () => notAvailNotices.dates.hide())
	}

	notAvailNotices.dates.show()
}

const showNotAvailFilters = () => {
	// показ Filters notice обнуляє лічильник спроб по датах
	resetNotAvailCount()

	if (!notAvailNotices.filters) {
		notAvailNotices.filters = new NotAvailFilters()

		notAvailNotices.filters.on(NOT_AVAIL_FILTERS_EVENTS.ADJUST, () =>
			filtersModal.show()
		)
		// рефетч запустить CLEAR стору
		notAvailNotices.filters.on(NOT_AVAIL_FILTERS_EVENTS.RESET, () =>
			filtersStore.clear()
		)
	}

	notAvailNotices.filters.show()
}

const showNotAvailIfNeeded = () => {
	if (checkAvail.availableHotels.length) {
		resetNotAvailCount()
		return
	}

	const filtersApplied = getSelectedFiltersCount(filtersStore.getData()) > 0

	if (filtersApplied && checkAvail.totalHotelsCountWithoutFilters > 0)
		showNotAvailFilters()
	else showNotAvailDates()
}

renderSearchResults()

showNotAvailIfNeeded()

updateFormInfoView(formStore.getData())

formStore.on('change', () => {
	updateFormInfoView(formStore.getData())
})
